export default __webpack_public_path__ + "static/media/growthinvestment_bar3.76f98e3e.svg";